import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import Icon from '@components/Icon';
import LoginAnimation from '@components/LoginAnimation';
import TickerText from '@components/LoginAnimation/TickerText';

import type { TLoadingPageProps } from './types';

import style from './styles.module.scss';

const LoadingPage = (props: TLoadingPageProps) => {
  const { delay = 8800, onBeforeRedirect } = props;

  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (id) {
        onBeforeRedirect?.();
        // No viewTransition because there is an explicit zoom out animation defined in LoginAnimation CSS.
        navigate(`/report/${id}`);
      } else {
        navigate('/not-found', { replace: true, viewTransition: true });
      }
    }, delay);

    return () => {
      return clearTimeout(timeout);
    };
  }, [id, delay, onBeforeRedirect, navigate]);

  return (
    <div className={style.container}>
      <div className={style['message-wrapper']}>
        <Icon
          name="barcode"
          size={40}
        />

        <dl className={style.message}>
          <dt>Opening vault: </dt>
          <dd>
            {id ? (
              <TickerText
                targetText={id}
                duration={2000}
              />
            ) : (
              'N/A'
            )}
          </dd>
        </dl>
      </div>
      <div className={style['animation-wrapper']}>{<LoginAnimation />}</div>
    </div>
  );
};

export default LoadingPage;
